import { Checkbox } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface FilesGridSelectAllProps {
  fileKeys: readonly string[]
  selectedKeys: ReadonlySet<string>
  onSelectionChange: (keys: string[]) => void
}

/** The grid view's counterpart to the list view's header Select all, with the same replace-the-selection semantics. */
export function FilesGridSelectAll({
  fileKeys,
  selectedKeys,
  onSelectionChange
}: FilesGridSelectAllProps) {
  const { t } = useTranslation()
  const selectedCount = fileKeys.filter((key) => selectedKeys.has(key)).length
  const allSelected = fileKeys.length > 0 && selectedCount === fileKeys.length
  const someSelected = selectedCount > 0 && !allSelected

  return (
    <Checkbox
      checked={allSelected}
      indeterminate={someSelected}
      aria-checked={someSelected ? "mixed" : allSelected}
      disabled={!fileKeys.length}
      onChange={(e) => onSelectionChange(e.target.checked ? [...fileKeys] : [])}
    >
      {t("files.selectAll")}
    </Checkbox>
  )
}
